import { styled } from 'styled-components';
import THEME from '../../../theme.js';
export const Section = styled.div `
  margin-bottom: 20px;
`;
export const HeaderRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;
export const Row = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  margin-bottom: 4px;
  opacity: ${(p) => (p.$deleted ? 0.4 : 1)};
  text-decoration: ${(p) => (p.$deleted ? 'line-through' : 'none')};

  .iris-input-container input {
    margin-bottom: 0;
  }
`;
export const Info = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const Label = styled.span `
  font-size: 0.95em;
  display: flex;
  align-items: center;
  gap: 6px;
`;
export const ReferenceId = styled.small `
  max-width: 120px;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${THEME.COLOR_GREY};
`;
export const DateText = styled.small `
  color: ${THEME.COLOR_GREY};
`;
export const Meta = styled.span `
  display: flex;
  align-items: center;
  gap: 6px;

  span {
    margin-bottom: 0;
  }
`;
export const RightCol = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const AmountCol = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;
export const Actions = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const IconButton = styled.button `
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${THEME.COLOR_GREY};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${THEME.COLOR_PRIMARY};
    background: #f0f0f0;
  }
`;
export const Amount = styled.span `
  font-weight: bold;
  white-space: nowrap;
`;
export const Percentage = styled.small `
  color: ${THEME.COLOR_GREY};
`;
export const AdditionRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  margin-bottom: 4px;
  background: ${THEME.COLOR_SECONDARY};

  .iris-input-container input {
    margin-bottom: 0;
  }
`;
export const RemainingRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  margin-bottom: 4px;
  opacity: 0.5;
`;
export const ButtonRow = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;
//# sourceMappingURL=CaseVoucherDistributionsStyles.js.map